<template>
  <div class="chargeCategoryConfig">
    <el-form :inline="true" class="demo-form-inline toolbar" style="padding-bottom:0px;" @submit.native.prevent>
      <el-form-item>
        <el-button type="primary" icon='' @click="handleAdd">添加缴费类别</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <!--表格内容栏-->
      <el-table border :data="tableData" :header-cell-style="tableHeaderColor" :span-method="objectSpanMethod" style="width:100%">
        <el-table-column prop="chargeModelName" label="收费模块" min-width="150" align=center></el-table-column>
        <el-table-column prop="name" label="类别" min-width="180" align=center></el-table-column>
        <el-table-column label="出院退费" min-width="200" align=center>
          <template slot-scope="scope">
            <span @click="handleClickLeaveHospital(scope.$index,scope.row)">
              <el-switch v-model="scope.row.isOutReturn" active-color="#13ce66" inactive-color="#ccc" active-text="是" inactive-text="否"></el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="请假退费" min-width="200" align=center>
          <template slot-scope="scope">
            <span @click="handleClickLeave(scope.$index,scope.row)">
              <el-switch v-model="scope.row.isLeaveReturn" active-color="#13ce66" inactive-color="#ccc" active-text="是" inactive-text="否"></el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="是否可以调整" min-width="200" align=center>
          <template slot-scope="scope">
            <span @click="handleClickAdjust(scope.$index,scope.row)">
              <el-switch v-model="scope.row.isAdjust" active-color="#13ce66" inactive-color="#ccc" active-text="是" inactive-text="否"></el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" align=center>
          <template slot-scope="scope">
            <img class="imgMarginLeft" src="@/assets/beadhouse/shanchu_icon.png" alt="" @click="handleDelete(scope.$index,scope.row)">
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 新建费用类别的dialog模态框-->
    <el-dialog title="添加缴费类别:" width="40%" :visible.sync="dialogVisibleFeeCategoryForm" :close-on-click-modal="false">
      <el-form :model="feeCategoryForm" label-width="120px" :rules="feeCategoryFormRules" ref="feeCategoryForm" label-position="right">
        <el-row class="feeCategoryFormRow">
          <el-form-item label="选择配置类型:" prop="modelCode">
            <el-select v-model="feeCategoryForm.modelCode" class="width80" @change="handleSelectConfigType">
              <el-option
                v-for="item in configTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row class="feeCategoryFormRowTransfer">
          <el-transfer v-model="itemIdlist"  :titles="['类别', '待添加的类别']" :data="transferData" @change="handleTransferChange">
            <span slot-scope="{ option }">{{ option.label }}</span>
          </el-transfer>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleFeeCategoryForm = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFeeCategoryForm" :loading="feeCategoryFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name:"ChargeCategoryConfig",
  components:{},
  data(){
    return {
      size: 'medium',//按钮的尺寸
      chargeCategoryManagement: {
  newFeeCategory: "新建费用类别",
  managementFeeCategory: "管理费用类别",
  addFeeItem: "添加费用项目",
  category: "类别",
  project: "项目",
  chargingStandard: "收费标准",
  serviceContent: "服务内容",
  operation: "操作",
  serviceCategory: "服务类别:",
  fixChargeCategoryName: "服务类别名称",
  categoryRemark: "类别说明:",
  categoryA: "本类别中项目是否可以多选:",
  categoryB: "本类别中是否必选一个项目:",
  categoryC: "本类别中是否默认选择第一个项目:",
  tip1: "*提示:床位费,护理费和押金是固定项目,无需再添加",
  tip2: "*提示:床位费,护理费和押金是固定类别,不能删除和修改类别名称",
  tip3:
    "*提示:周期缴费项目为不固定的金额类别中是否默认选中第一项必须为是（如：电费、水费）",
  yes: "是",
  no: "否",
  addFeeitem: "添加费用项目",
  editFeeitem: "修改费用项目",
  type: "类型",
  chargeStandard: "收费标准",
  project: "项目",
  chargeStyle: "收费方式",
  moneyType: "金额类型",
  careLevel: "护理等级",
  serviceContent: "服务内容",
  roomType: "房间类型",
  orientation: "朝向",
  isHaveToilet: "是否带厕所",
  notEmpty: "不能为空",
  onlyNumber: "请输入阿拉伯数字",
  loadingText: "拼命加载中......",
  maxText: "最多不能超过20个字符"
},//引入 lang 里面的字符串资源,
      spanArr:[],//spanArr是一个空的数组，用于存放每一行记录的合并数；
      pos:0,//pos是spanArr的索引
      //表格数据源模拟数据
      tableData: [],
      //新增费用类别的dialog配置
      dialogVisibleFeeCategoryForm:false,//dialog默认是关闭
      feeCategoryFormLoading:false,//确定按钮的loading加载  默认为false
      feeCategoryForm:{},//数据源
      feeCategoryFormRules:{//正则
        modelCode:[{required: true, message: "不能为空" , trigger: 'change'},]
      },
      configTypeOptions:[],//配置类型的数据
      //穿梭框的数据
      transferData:[],
      itemIdlist: []
    }
  },
  methods:{
    /* 
      添加缴费类别
    */
    handleAdd(){
      if(this.$refs.feeCategoryForm!=undefined){
        this.$refs['feeCategoryForm'].resetFields();
      }
      this.dialogVisibleFeeCategoryForm = true;
      this.feeCategoryForm={
        modelCode:"",
      }
      this.queryAllCategory();//刷新穿梭框的数据
      this.itemIdlist=[];//清空数据
    },

    /* 
      配置类型下拉框的change事件
    */
    handleSelectConfigType(value){
      console.log(value);
      this.feeCategoryForm.modelCode=value*1;
    },

    /* 
      穿梭框的change事件
    */
    handleTransferChange(value){
      console.log(value);
      
    },

    /* 
      缴费类别配置添加提交数据
    */
    submitFeeCategoryForm(){
      this.$refs.feeCategoryForm.validate((valid) => {
        if (valid) {
          if(this.itemIdlist.length>0){
            let params=[];
            this.itemIdlist.forEach(item=>{
              let itemIdObj={};
              itemIdObj.expenseTypeId=item*1;
              itemIdObj.modelCode=this.feeCategoryForm.modelCode;
              itemIdObj.isOutReturn=0;//是否退院退费 0.否 1.是    默认传0
              itemIdObj.isLeaveReturn=0;//是否请假退费 0.否 1.是   默认传0
              itemIdObj.isAdjust=0;//是否可以调整 0.否 1.是    默认传0
              params.push(itemIdObj);
            })
            console.log(params);
            this.feeCategoryFormLoading=true;
            this.$postJson('fmc/feeItem/bindChargeModel',params).then(res=>{
              console.log(res);
              if(res.code==200){
                this.$message({message:res.message,type:"success"});
              }else{
                this.$message({message:res.message,type:"error"});
              }
              this.$refs['feeCategoryForm'].resetFields();
              this.feeCategoryFormLoading=false;
              this.dialogVisibleFeeCategoryForm=false;
              this.queryList();//刷新表格的数据
            })
          }else{
            this.$message({message:"请选择类别",type:"error"});
          }
        }
      })
    },

    /* 
      改变(出院是否退费)配置
    */
    handleClickLeaveHospital(index,row){
      console.log(index,row);
      let id=row.id;
      this.$postJson('fmc/feeItem/toggleOutReturn/'+id).then(res=>{
        console.log(res);
        if(res.code==200){
          this.$message({message:res.message,type:"success"});
        }else{
          this.$message({message:res.message,type:"error"});
        }
        this.queryList();
      })
    },

    /* 
      改变(请假是否退费)配置
    */
    handleClickLeave(index,row){
      console.log(index,row);
      let id=row.id;
      this.$postJson('fmc/feeItem/toggleLeaveReturn/'+id).then(res=>{
        console.log(res);
        if(res.code==200){
          this.$message({message:res.message,type:"success"});
        }else{
          this.$message({message:res.message,type:"error"});
        }
        this.queryList();
      })
    },

    /* 
      改变(费用是否可调整)配置
    */
    handleClickAdjust(index,row){
      console.log(index,row);
      let id=row.id;
      this.$postJson('fmc/feeItem/toggleAdjustable/'+id).then(res=>{
        console.log(res);
        if(res.code==200){
          this.$message({message:res.message,type:"success"});
        }else{
          this.$message({message:res.message,type:"error"});
        }
        this.queryList();
      })
    },

    /* 
      删除表格行数据
    */
    handleDelete(index,row){
      console.log(index,row);
      this.$confirm('确定要删除该配置项吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        let id=row.id;//费用类别配置ID
        this.$postForm('fmc/feeItem/deleteChargeModel/'+id).then(res=>{
          console.log(res);
          if(res.code==200){
              this.$message({message:res.message,type:"success"});
          }else{
              this.$message({message:res.message,type:"error"});
          }
          this.queryList();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    /* 
      查询费用模块名
    */
    selectChargeModelByName(){
      var configType =[{chargeModelName:"入院收费",modelCode:1},{chargeModelName:"周期收费",modelCode:2},{chargeModelName:"出院收费",modelCode:3},{chargeModelName:"非周期收费",modelCode:4}];
      for(var i = 0; i < configType.length; i++) {
        var item = {};
        item.value = configType[i].modelCode;
        item.label = configType[i].chargeModelName;
        this.configTypeOptions.push(item)
      }
      console.log(this.configTypeOptions,"this.configTypeOptions");
    },

    /* 
      查询类别
    */
    queryAllCategory(){
      this.transferData=[];//请求之前先将数据置空，防止累加
      this.$postJson('fmc/feeItem/queryAllTypes').then(res=>{
        console.log(res);
        var transferList=res.result;
        for (let i = 0; i <transferList.length; i++) {
          console.log(transferList[i],"transferList")
          this.transferData.push({
            key: transferList[i].id,
            label: transferList[i].name,
          });
        }
        console.log(this.transferData);
      })
    },

    /* 
      查询费用类别配置列表
    */
    queryList(){
      this.tableData=[];//请求之前清空数据，防止累加
      var arrOneList=[];
      var arrTwoList=[];
      var arrThreeList=[];
      var arrFourList=[];
      this.$postJson('fmc/feeItem/queryAllChargeModels').then(res=>{
        console.log(res);
        //两次循环处理得到想要的table表格的json数据
        if(res.code==200){
          if(res.result!=null || res.result!=undefined ||res.result.length>0){
            res.result.forEach(item=>{
              console.log(item);
              let chargeConfigObj={};
              chargeConfigObj.chargeModelName=item.modelCode==1 ? "入院收费" :(item.modelCode==2 ? "周期收费" : (item.modelCode==3 ? "出院收费" : "非周期收费"));
              //把同一类的数据放在一数组中   1- 入院收费 2-周期收费 3-出院收费 4-非周期收费
              if(item.modelCode==1){
                chargeConfigObj.id=item.id;
                chargeConfigObj.modelCode=item.modelCode;
                chargeConfigObj.expenseTypeId=item.expenseTypeId;
                chargeConfigObj.isOutReturn=Boolean(item.isOutReturn);
                chargeConfigObj.isLeaveReturn=Boolean(item.isLeaveReturn);
                chargeConfigObj.isAdjust=Boolean(item.isAdjust);
                chargeConfigObj.name=item.name;
                arrOneList.push(chargeConfigObj);
              }else if(item.modelCode==2){
                chargeConfigObj.id=item.id;
                chargeConfigObj.modelCode=item.modelCode;
                chargeConfigObj.expenseTypeId=item.expenseTypeId;
                chargeConfigObj.isOutReturn=Boolean(item.isOutReturn);
                chargeConfigObj.isLeaveReturn=Boolean(item.isLeaveReturn);
                chargeConfigObj.isAdjust=Boolean(item.isAdjust);
                chargeConfigObj.name=item.name;
                arrTwoList.push(chargeConfigObj);
              }else if(item.modelCode==3){
                chargeConfigObj.id=item.id;
                chargeConfigObj.modelCode=item.modelCode;
                chargeConfigObj.expenseTypeId=item.expenseTypeId;
                chargeConfigObj.isOutReturn=Boolean(item.isOutReturn);
                chargeConfigObj.isLeaveReturn=Boolean(item.isLeaveReturn);
                chargeConfigObj.isAdjust=Boolean(item.isAdjust);
                chargeConfigObj.name=item.name;
                arrThreeList.push(chargeConfigObj);
              }else if(item.modelCode==4){
                chargeConfigObj.id=item.id;
                chargeConfigObj.modelCode=item.modelCode;
                chargeConfigObj.expenseTypeId=item.expenseTypeId;
                chargeConfigObj.isOutReturn=Boolean(item.isOutReturn);
                chargeConfigObj.isLeaveReturn=Boolean(item.isLeaveReturn);
                chargeConfigObj.isAdjust=Boolean(item.isAdjust);
                chargeConfigObj.name=item.name;
                arrFourList.push(chargeConfigObj);
              } 
              
            })
          }
        }
        console.log(arrOneList,arrTwoList,arrThreeList,arrFourList,"三个数组的值")
        this.tableData=this.tableData.concat(arrOneList).concat(arrTwoList).concat(arrThreeList).concat(arrFourList);//合并数组
        console.log(this.tableData,"this.tableData-----------");
        this.getSpanArr(this.tableData);
      })
    },

    /* 
      处理表格的数据 用于合并表格
    */
    getSpanArr(data) {　
      this.spanArr=[];//重置数据，防止数据累加
      this.pos=0;//重置数据，防止数据累加
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0
         } else {
          // 判断当前元素与上一个元素是否相同  通过表格中的 modelCode模块的modelCode字段来判断 它们是否是一类  
          if (data[i].modelCode === data[i - 1].modelCode) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
      console.log(this.spanArr,"this.spanArr");
    },

    /* 
      表格 类别的合并
    */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(this.spanArr,"this.spanArr...........................");
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        console.log(_row,_col);
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },

    /* 
      表头的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }){
      if (rowIndex === 0) {
        return 'background-color:#bee1f4;color:#6f7075;font-weight: 700;height:50px;'
      }
    },
  },
  created(){
  
  },
  mounted(){
    this.selectChargeModelByName();
    this.queryList();
    this.queryAllCategory();
  }
}
</script>
<style lang="scss" scoped>
  .chargeCategoryConfig{
    min-width: 1360px;
    padding-bottom:30px;
    background: #FEFEFE;
    .imgMarginLeft{
      margin-left:10px;
      cursor: pointer;
    }
    .radiomargiTtop{
      margin-top:13px;
    }
    .feeCategoryFormRow{
      width:80%;
      margin:0 auto;
    }
    .feeCategoryFormRowTransfer{
      width:90%;
      margin:0 auto;
    }
  }
  ::v-deep .el-transfer-panel__item{
    width:70%;
  }
</style>